import { BaseExportService } from "./BaseExportService";

export class RsaIdExportService extends BaseExportService {
  constructor(data, metadata = {}) {
    super(data, metadata);
  }

  get_filename_prefix() {
    return `RSA_ID_Report_${this.data?.IdNumber || "Unknown"}`;
  }

  get_available_sections() {
    return {
      verification_results: "Verification Results",
      personal_details: "Personal Details",
      safps_results: "SAFPS Results",
      raw_json: "Raw JSON Data",
    };
  }

  get_default_export_options() {
    return {
      verification_results: true,
      personal_details: true,
      safps_results: true,
      raw_json: false,
    };
  }

  prepare_export_data(export_options) {
    const export_data = {};

    if (export_options.verification_results) {
      export_data.verification_results = this.prepare_verification_results();
    }

    if (export_options.personal_details) {
      export_data.personal_details = this.prepare_personal_details();
    }

    if (export_options.safps_results) {
      export_data.safps_results = this.prepare_safps_results();
    }

    if (export_options.raw_json) {
      export_data.raw_json = [this.data];
    }

    return export_data;
  }

  prepare_verification_results() {
    const face_result = this.data?.FaceResult || {};
    return [
      {
        Status: this.data?.Status,
        Message: this.data?.Message,
        "First Name Matches": this.data?.FirstNameResult,
        "Last Name Matches": this.data?.LastNameResult,
        "Face Match": face_result.isIdentical ? "Yes" : "No",
        "Face Match Confidence": face_result.confidence,
        Deceased: this.data?.DeadIndicator ? "Yes" : "No",
        "ID Blocked": this.data?.IDBlocked ? "Yes" : "No",
      },
    ];
  }

  prepare_personal_details() {
    return [
      {
        "First Name": this.data?.FirstName,
        "Last Name": this.data?.LastName,
        "ID Number": this.data?.IdNumber,
        "Date of Birth": this.data?.IDIssueDate, // Note: using issue date as DOB was not explicitly in root but implied by ID
        Gender: this.data?.Gender, // If available
        "Marital Status": this.data?.MaritalStatus,
        "Country of Birth": this.data?.BirthPlaceCountry,
      },
    ];
  }

  prepare_safps_results() {
    const results = this.data?.SAFPSResults || [];
    if (results.length === 0) {
      return [{ Info: "No SAFPS records found." }];
    }
    return results;
  }
}
